/**
 * The product image box on public gear pages. Shared by the static poster and
 * the 3D viewer that replaces it, so the swap moves nothing (CLS), and by the
 * category tiles. White in both themes: a product-photography convention the
 * editor's GearImageTile follows too, not a themed surface.
 */
export const PRODUCT_STAGE_CLASS = 'relative aspect-square w-full overflow-hidden rounded-xl bg-white';

/**
 * The stage where it stands on its own — the product page's lead picture,
 * poster and live model alike. Inside a grid tile the card around it is the
 * edge; here nothing is, and a white square straight on the dark page reads
 * as a hole rather than a stage. So it takes the showroom tiles' own lift
 * (`.rt-product-lift`, the homepage's gear wall) and a hairline.
 */
export const PRODUCT_HERO_STAGE_CLASS = `${PRODUCT_STAGE_CLASS} rt-product-lift border border-[var(--app-border)]`;

/** The committed static render of a product (web/scripts/catalog/render.ts thumbs). */
export function thumbPath(productId: string): string {
  return `/catalog/thumbs/${productId}.png`;
}
